(function ($) {
  "use strict";

  var DEFAULTS = {
    viewportSelector: ".hero_carousel",
    itemSelector: ".hero_carousel_slide",
    transitionDuration: 600,
    stepPercent: 100,
    swipeThreshold: 40,
    duration: 5000,
    line_time: ".hero_line_scroll",
    btn_play: ".hero_button_play",
    isAutoPlay: true
  };

  function setupInfiniteItems($viewport, settings) {
    var $items = $viewport.children(settings.itemSelector);
    var total = $items.length;
    
    if (!total) {
      return { total: 0 };
    }

    if (!$viewport.data("carousel-original-html")) {
      $viewport.data("carousel-original-html", $viewport.html());
    } else {
      $viewport.html($viewport.data("carousel-original-html"));
      $items = $viewport.children(settings.itemSelector);
      total = $items.length;
    }

    var $first = $items.first().clone(true, true).addClass("clone-card");
    var $last = $items.last().clone(true, true).addClass("clone-card");

    $viewport.empty().append($last);
    $viewport.append($items);

    if (total > 1) {
      $viewport.append($items.clone(true, true));
    }

    $viewport.append($first);

    return {
      total: total,
      minIndex: 1,
      maxIndex: total > 1 ? total : 1,
      resetLeftIndex: total,
      resetRightIndex: 1
    };
  }

  function applyTranslate($items, index, settings, withAnimation) {
    var translateX = -(index * settings.stepPercent);
    var duration = withAnimation ? settings.transitionDuration : 0;

    $items.css({
      transition: "transform " + duration + "ms ease",
      transform: "translateX(" + translateX + "%)"
    });
  }

  function initCarousel($root, options) {
    
    var settings = $.extend({}, DEFAULTS, options || {});

    if ($root.data("carousel-initialized")) {
      return;
    }

    var $viewport = $root.find(settings.viewportSelector).first();
    if (!$viewport.length) {
      return;
    }

    var structure = setupInfiniteItems($viewport, settings);
    if (!structure.total) {
      return;
    }

    var currentIndex = structure.minIndex;
    var isAnimating = false;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var touchDeltaY = 0;
    var isSwiping = false;
    var isPlaying = false;
    var autoPlayTimeout;
    var currentTimeout = 0;
    var lineTimeParentWidth = $root.find(settings.line_time).first().parent().width();


    var $allItems = $viewport.children(settings.itemSelector);
    applyTranslate($allItems, currentIndex, settings, false);

    function animateLineTime(duration) {
        var $lineTime = $root.find(settings.line_time).first();
        if (!$lineTime.length) {
            return;
        }
        $lineTime.css({
            transition: "width " + duration + "ms linear",
            width: "100%"
        });


    }

    function autoPlay(remainingDuration = 0) {
         if (structure.total > 1) {
            var $lineTime = $root.find(settings.line_time).first();
            if (remainingDuration == 0) {
                $lineTime.css({
                    transition: "none",
                    width: "0%"
                });
            }
            var dd = remainingDuration > 0 ? remainingDuration : settings.duration;
            setTimeout(function() {
                animateLineTime(dd);
            }, 50);
            
            autoPlayTimeout = window.setTimeout(function () {
                moveRight();
                autoPlay();
            }, dd + 60);
         }
    }

    function playAndPause(){
        if (!isPlaying) {
            isPlaying = true;
            var $lineTime = $root.find(settings.line_time).first();
            var currentWidth = $lineTime.width();
            var currentPercent = (currentWidth / lineTimeParentWidth) * 100;
            var remainingDuration = (100 - currentPercent) / 100 * settings.duration;

            autoPlay(remainingDuration);
        } else {
            isPlaying = false;
            var $lineTime = $root.find(settings.line_time).first();
            var wLinetime = $lineTime.width();

            $lineTime.css({
                transition: "none",
                width: wLinetime + "px"
            });

            if (autoPlayTimeout) {
                clearTimeout(autoPlayTimeout);
            }
        }
    }

    $root.find(settings.btn_play).first().on("click", function(event) {
        event.preventDefault();
        $(this).toggleClass("playing");
        $(this).toggleClass("stopped");
        playAndPause();
        return false;
    });

    if (settings.isAutoPlay) {
        playAndPause();
    }

    function moveRight() {
      if (isAnimating) {
        return;
      }

      isAnimating = true;
      currentIndex += 1;
      applyTranslate($allItems, currentIndex, settings, true);

      window.setTimeout(function () {
        if (currentIndex > structure.maxIndex) {
          currentIndex = structure.resetRightIndex;
          applyTranslate($allItems, currentIndex, settings, false);
        }
        isAnimating = false;
      }, settings.transitionDuration);
    }

    function moveLeft() {
      if (isAnimating) {
        return;
      }

      isAnimating = true;
      currentIndex -= 1;
      applyTranslate($allItems, currentIndex, settings, true);

      window.setTimeout(function () {
        if (currentIndex < structure.minIndex) {
          currentIndex = structure.resetLeftIndex;
          applyTranslate($allItems, currentIndex, settings, false);
        }
        isAnimating = false;
      }, settings.transitionDuration);
    }

    function onTouchStart(event) {
      var touch = event.originalEvent && event.originalEvent.touches
        ? event.originalEvent.touches[0]
        : null;

      if (!touch) {
        return;
      }

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchDeltaX = 0;
      touchDeltaY = 0;
      isSwiping = true;
    }

    function onTouchMove(event) {
      if (!isSwiping) {
        return;
      }

      var touch = event.originalEvent && event.originalEvent.touches
        ? event.originalEvent.touches[0]
        : null;

      if (!touch) {
        return;
      }

      touchDeltaX = touch.clientX - touchStartX;
      touchDeltaY = touch.clientY - touchStartY;
    }

    function onTouchEnd() {
      if (!isSwiping) {
        return;
      }

      isSwiping = false;

      var absX = Math.abs(touchDeltaX);
      var absY = Math.abs(touchDeltaY);

      if (absX < settings.swipeThreshold || absX <= absY) {
        return;
      }

      if (touchDeltaX < 0) {
        moveRight();
      } else {
        moveLeft();
      }
    }

    if (structure.total > 1) {
      $viewport.on("touchstart", onTouchStart);
      $viewport.on("touchmove", onTouchMove);
      $viewport.on("touchend touchcancel", onTouchEnd);
    }

    $root.data("carousel-initialized", true);
    $root.data("carousel-api", {
      next: moveRight,
      prev: moveLeft
    });

    function onResize() {
      applyTranslate($allItems, currentIndex, settings, false);
    }

    $(window).on("resize", onResize);
  }

  window.ProjectCardsCarousel = {
    init: function (selector, options) {
      if (!selector) {
        return;
      }

      $(selector).each(function () {
        initCarousel($(this), options);
      });
    },
    playAndPauseAll: function(state = null) {
        $(".hero_button_play."+state).each(function() {
            $(this).trigger("click");
        });
    }
  };
})(window.jQuery);
